import axios, { AxiosInstance } from 'axios';
import Cookies from 'js-cookie';

const apiClient: AxiosInstance = axios.create({
  baseURL: `${process.env.REACT_APP_BACKEND}/api/realstate`,
  headers: {
    'Content-Type': 'application/json',
  },
});

apiClient.interceptors.request.use(
  (config) => {
    const storedToken = Cookies.get('token');
    if (storedToken) {
      config.headers.Authorization = `Bearer ${storedToken}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

export interface IFilterProperty {
  addressCity?: string;
  addressState?: string;
  homeType?: string[];
  loanTypes?: string[];
  minPrice?: number;
  maxPrice?: number;
  minEquity?: number;
  maxEquty?: number;
  minInterestRate?: number;
  maxInterestRate?: number;
  hasEmail?: boolean;
}
export interface IFilterPropertyFetch {
  addressCity?: string;
  addressState?: string;
  homeType?: string[];
  loanTypes?: string[];
  minPrice?: number;
  maxPrice?: number;
  minEquity?: number;
  maxEquty?: number;
  minInterestRate?: number;
  maxInterestRate?: number;
  Leads?: number;
}
export interface IPagination {
  page?: number;
  lastpage?: number;
}

export interface IProperty {
  id: number;
  agentEmail?: string;
  address?: string;
  addressCity?: string;
  addressState?: string;
  addressStreet?: string;
  addressZipcode?: string;

  agentLicenseNumber?: string;
  agentName?: string;
  agentPhoneNumber?: string;
  apn_info?: string;
  brokerName?: string;
  brokerPhoneNumber?: string;
  coAgentName?: string;
  coAgentNumber?: string;
  homeStatus?: string;
  homeType?: string;
  interest_rate?: number;
  legal_description?: string;
  loan_balances?: number;
  loan_payments?: number;
  loan_types?: string;
  owner_name?: string;
  pgapt?: string;
  price?: number;
  priceChange?: number;
  priceForHDP?: number;
  rentZestimate?: number;
  taxAssessedValue?: number;
  zestimate?: number;
  zpid?: string;
  equity?: number;

  createdAt?: string;
  updatedAt?: string;
}

export interface ICityStat {
  city: string;
  count: number;
}

export interface IPropertyStats {
  cities: ICityStat[];
  totalCount: number;
  averagePrice: number;
  minPrice: number;
  maxPrice: number;
  averageInterestRate: number;
  minInterestRate: number;
  maxInterestRate: number;
}
export async function fetchFilteredData(filter: IFilterPropertyFetch): Promise<IProperty[]> {
  try {
    const params = {
      ...filter,
    };
    const response = await apiClient.get<IProperty[]>('/fetchFilteredData', { params });
    return response.data;
  } catch (error: any) {
    throw new Error(error.response?.data?.message || 'Invalid Filter');
  }
}

export async function fetchStats(params: IFilterProperty): Promise<IPropertyStats[]> {
  try {



    const response = await apiClient.get<IPropertyStats[]>('/stats', { params });
    return response.data;
  } catch (error: any) {
    throw new Error(error.response?.data?.message || 'Invalid Filter');
  }
}